module.exports = __webpack_public_path__ + "media/images/redesign-images/sorority/sorority-collab-medium-77aad73cf3b19416ba4ca5c1dbab06e6.jpg";